module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "social-icon"
  }, [_c('a', {
    attrs: {
      "href": _vm.network.profileUrl,
      "target": "_blank"
    },
    on: {
      "click": _vm.recordLead
    }
  }, [(_vm.network.network === 'linkedin') ? _c('img', {
    attrs: {
      "src": require("../assets/icons/linkedin.svg")
    }
  }) : (_vm.network.network === 'facebook') ? _c('img', {
    attrs: {
      "src": require("../assets/icons/facebook.svg")
    }
  }) : (_vm.network.network === 'twitter') ? _c('img', {
    attrs: {
      "src": require("../assets/icons/twitter.svg")
    }
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a56e0116","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SocialIcons.vue
// module id = 488
// module chunks = 0